import React, { Component } from "react";

// React Router
import { Link } from 'react-router-dom';

// Stores
import UserProfileStore from '../../Stores/UserProfileStore';

// Utils
import { GoogleAnalytics } from '../../Utils';

// Components
import { RightMenu, StatusMenu } from './';

// Styles
import './navbar.css';
import '../../assets/css/animations.css';

class Navbar extends Component {

    constructor(props) {
        
        super(props);

        this.state = {
            user: null,
            username: "Log In / Signup",
            menuClass: 'hamburger hamburger--3dx'
        };

        this.logout = this.logout.bind(this);
    }

    // After Navbar renders for first time, check for user
    componentDidMount() {

        //console.log('Navbar.componentDidMount()');

        var user = UserProfileStore.getUser();

        if(user !== null) {
            this.setState((prev, props) => {
                return {
                    user : user,
                    username : user.username
                }
            });
        }

    }


    // Logs a user out of the app
    logout() {

        UserProfileStore.removeUser()
            .then( (success) => {

                this.setState((prev, props) => {
                    return {
                        user : null,
                        username : 'Log In'
                    }
                });

            });
    }

    // Opens and closes the meun
    openMenu = () => {
        var newMenu = 'hamburger hamburger--3dx';
        
        if(this.state.menuClass === 'hamburger hamburger--3dx')
            newMenu += ' is-active';
         
        this.setState((prevState, props) => {
            return {
                menuClass: newMenu
            }
        });
    }


    // Log route click to GoogleAnalytics and close menu
    navigate = (route) => {

        GoogleAnalytics.newPage(route);

        this.setState((prevState, props) => {
            return {
                menuClass: 'hamburger hamburger--3dx'
            }
        });

    }


    // Given a new screen size, assess if its worth changing and change it
    updateScreenSize = ({width, height}) => {
        
        //console.log('Navbar.updateScreenSize()');

        this.setState((prevState, props) => {
            return {
                screenWidth : width
            }
        });

    }


    // based on mobile or not, return the proper menu
    getMenu(mobile) {

        var menu = null;

        var rightMenu = (<RightMenu mobile={mobile} user={this.state.user} username={this.state.username} onLogout={this.logout} mobileNavigate={() => this.navigate}/>);

        var statuses = (<StatusMenu mobile={mobile} details={this.props.details} statuses={this.props.statuses} />);

        if(!mobile) {

            menu = (
                <div>
                    <ul className="nav navbar-nav">
                    
                        <li><Link to="/dashboard" onClick={GoogleAnalytics.newPage('/dashboard')}><i className="icon-grid5 position-left"></i><span>Dashboard</span></Link></li>
                        <li><Link to="/markets" onClick={GoogleAnalytics.newPage('/markets')}><i className="icon-statistics position-left"></i><span>Markets</span></Link></li>
                        <li><Link to="/charts" onClick={GoogleAnalytics.newPage('/charts')}><i className="icon-graph position-left"></i><span>Charts</span></Link></li>
                        {/*<li><Link to="/peak" onClick={GoogleAnalytics.newPage('/peak')}><i className="icon-flip-horizontal2 position-left"></i><span>Peak</span></Link></li>*/}
                        { this.state.user !== null ? (<li><Link to="/apikeys" id='apikeys' onClick={GoogleAnalytics.newPage('/apikeys')} ><i className="icon-key position-left"></i><span>API Keys</span></Link></li>) : null }
                    </ul>
        
                    <ul className="nav navbar-nav navbar-right">
                        {statuses}
                        {rightMenu}     
                    </ul>
                </div>
            );

        }
        else {

            menu = (
                <div id='hamburger-mobile'>
                    <div className="dropdown">
                        <button className={this.state.menuClass} type="button" 
                        data-toggle="dropdown" aria-expanded="true"  onClick={this.openMenu}>
                            <span className="hamburger-box">
                                <span className="hamburger-inner"></span>
                            </span>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-right mobile-navbar-dropdown">
                            <li><Link to="/dashboard" onClick={() => this.navigate('/dashboard')}><i className="icon-grid5 position-left"></i><span>Dashboard</span></Link></li>
                            <li><Link to="/markets" onClick={() => this.navigate('/markets')}><i className="icon-statistics position-left"></i><span>Markets</span></Link></li>
                            <li><Link to="/charts" onClick={() => this.navigate('/charts')}><i className="icon-graph position-left"></i><span>Charts</span></Link></li>
                            {/*<li><Link to="/peak" onClick={() => this.navigate('/peak')}><i className="icon-flip-horizontal2 position-left"></i><span>Peak</span></Link></li>*/}
                            {rightMenu}
                            <li className="divider" style={{background:'#343344'}}></li>
                            {statuses}
                        </ul>
                    </div>
                </div>
            );
            
            
        }

        return menu;
    }

    // Navbar Render function
    render() {

        const mobile = window.innerWidth < 1024 ? true : false;

        const menu = this.getMenu(mobile);

        const production = this.props.details.environment === 'prod' ? true : false;

        return (
            
            <div className="navbar" id={mobile ? 'container-mobile' : ''}>

                {/*----------------- Navbar Header ------------------*/}
                <div className="navbar-header" id={mobile ? 'logo-mobile' : ''}>
                    
                    <Link to="/dashboard" className="navbar-brand" id='navbar-header'>
                        <img id="yety-logo" src="/assets/img/logo.svg" alt="" ></img>
                        <div id="yety-text" className={production ? 'prod' : ''}>
                            yety
                            <div id="yety-env" className={production ? 'hidden-codename' : ''}><span>{ production ? this.props.details.codename : this.props.details.environment }</span></div>
                        </div>
                    </Link>

                </div>
                {/*----------------- / Navbar Header ------------------*/}

                {menu}

            </div>

        );
    }
}

export default Navbar;








// WEBPACK FOOTER //
// ./src/Components/Navbar/Navbar.js